import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import GHSubGroup from "@/components/GHSubGroup";
import { loadImageEnd } from "@/utils/images";
export default {
  name: "GHGroupVector",
  components: {
    GHSubGroup: GHSubGroup
    /*小组01*/

  },
  methods: {
    collectAllIcons: function collectAllIcons() {
      var _this = this;

      var allIcons = [];
      this.subCategory.groups.forEach(function (group) {
        group.forEach(function (item) {
          allIcons.push(item.icon);
        });
      });
      loadImageEnd(allIcons, function () {
        _this.isLoading = false;
      });
    },
    sendCompId: function sendCompId(id) {
      this.$emit('clickComponent', id); // this.selectedIconId = id; // 更新父组件内的选中状态
    }
  },
  beforeMount: function beforeMount() {
    this.collectAllIcons();
  },
  props: {
    subCategory: Object,
    rows: Number
  },
  data: function data() {
    return {
      isLoading: true // selectedIconId: null, // 跟踪被选中的图标

    };
  }
};